import { observable } from 'mobx';

export class CurrentUserModel {
  @observable public name: string = '';
  @observable public tipoUsuario?: TipoUsuario = undefined;
  @observable public cpf: string = '';
}

export enum TipoUsuario {
  Aluno,
  Professor,
  Funcionario
}